const PAQSHOT_BRAND = '-paqshot.com';

export function buildDownloadFilename(filename: string, format: 'jpg' | 'png'): string {
  let base = String(filename || 'image')
    .replace(/\.(jpg|jpeg|png)$/i, '')
    .trim() || 'image';

  if (!base.includes(PAQSHOT_BRAND)) {
    base = `${base}${PAQSHOT_BRAND}`;
  }

  return `${base}.${format}`;
}
